export { renderDrawerHeader_unstable as renderDrawerHeader } from '@fluentui/react-drawer';
